import { render } from "./NewHotel.vue?vue&type=template&id=c03491b2&scoped=true"
import script from "./NewHotel.vue?vue&type=script&lang=js"
export * from "./NewHotel.vue?vue&type=script&lang=js"

import "./NewHotel.vue?vue&type=style&index=0&id=c03491b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c03491b2"]])

export default __exports__